// Secure Supabase configuration: no production defaults in repo.

export const SUPABASE_CONFIG = {
  url: "http://localhost:54321",
  anonKey: "TEST_KEY_ONLY_FOR_LOCALHOST",
};

export const getSupabaseConfig = () => {
  const mode =
    (import.meta as any).env?.MODE || process.env.NODE_ENV || "development";
  const url = (import.meta as any).env?.VITE_SUPABASE_URL ?? "";
  const anonKey = (import.meta as any).env?.VITE_SUPABASE_ANON_KEY ?? "";

  const resolvedUrl = url || (mode === "test" ? SUPABASE_CONFIG.url : "");
  const resolvedAnon =
    anonKey || (mode === "test" ? SUPABASE_CONFIG.anonKey : "");

  if (!resolvedUrl || !resolvedAnon) {
    throw new Error(
      "Supabase URL/Anon Key fehlen. Setze VITE_SUPABASE_URL und VITE_SUPABASE_ANON_KEY (.env.*)."
    );
  }

  // Safety: In non-production block real supabase.co URLs unless explicitly allowed
  const allowProd = (import.meta as any).env?.VITE_ALLOW_PROD === "true";
  if (
    mode !== "production" &&
    !allowProd &&
    /https?:\/\/[^\s]+\.supabase\.co/i.test(resolvedUrl) &&
    !/localhost|127\.0\.0\.1/.test(resolvedUrl)
  ) {
    throw new Error(
      `🚫 SICHERHEITSBLOCK: Production Supabase-URL in Development-Modus erkannt.\n\nURL: ${resolvedUrl}\n\nLösung:\n1. Setze VITE_ALLOW_PROD=true in deiner .env Datei, wenn du bewusst gegen Production arbeiten möchtest.\n2. Oder verwende eine lokale Supabase-Instanz (z.B. http://localhost:54321).\n\nDieser Block verhindert versehentliche Production-Aufrufe in Development.`
    );
  }

  return { url: resolvedUrl, anonKey: resolvedAnon };
};
